import React from 'react';
import { Link } from 'gatsby';

import * as styles from './tags.module.css';
import { TAG_SHOW } from '../utils/routeConstants';

const Tags = ({ tags }) =>
  tags?.length > 0 && (
    <small className={styles.tags}>
      {tags.map((tag) => (
        <Link key={tag} to={TAG_SHOW(tag)} className={styles.tag}>
          {tag}
        </Link>
      ))}
    </small>
  );

export default Tags;
